import { useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n0 } from "../../lib/format";
import { Notice } from "../../lib/ui";

/* Product count sheet – port of productprint.php (API: /api/products/count-sheet). Print it, then write counted quantities in the blank column. */

export default function CountSheet() {
  const api = useApi();
  const [f, setF] = useState({ search: "", type: "" });
  const [form, setForm] = useState(f);
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/products/count-sheet", f).then(setD).catch((e) => setError(e.message)); }, [api, f]);
  return (
    <main className="pg" style={{ maxWidth: "72rem" }}>
      <PageHeader slug="productprint" actions={<button type="button" className="btn primary" onClick={() => window.print()}><i className="fas fa-print" /> Print</button>} />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel no-print" style={{ marginBottom: "1.25rem" }}>
        <form className="toolbar" style={{ borderBottom: 0 }} onSubmit={(e) => { e.preventDefault(); setF({ ...form }); }}>
          <div className="field grow"><label htmlFor="cs-q">Search name, manufacturer or barcode</label><input id="cs-q" value={form.search} onChange={(e) => setForm({ ...form, search: e.target.value })} placeholder="e.g. Coca Cola" /></div>
          <div className="field"><label htmlFor="cs-t">Product type</label><select id="cs-t" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
            <option value="">All types</option>{(d?.types || []).map((t) => <option key={t}>{t}</option>)}</select></div>
          <button type="submit" className="btn primary">Apply</button>
          <button type="button" className="btn" onClick={() => { setForm({ search: "", type: "" }); setF({ search: "", type: "" }); }}>Reset</button>
        </form>
      </section>
      <div className="print-only" style={{ marginBottom: ".8rem" }}>
        <h1 style={{ fontSize: "1.1rem", margin: 0 }}>AE2C Enterprise — Product count sheet</h1>
        <p style={{ fontSize: ".75rem", margin: ".2rem 0" }}>Printed {new Date().toLocaleString("en-GB")}{f.type && ` · Type: ${f.type}`}{f.search && ` · Search: "${f.search}"`}</p>
        <div style={{ display: "flex", justifyContent: "space-between", border: "1px solid #999", padding: ".4rem .6rem", fontSize: ".8rem" }}><span>Counted by: ____________________</span><span>Date: ____________________</span></div>
      </div>
      <section className="panel">
        <div className="tbl-wrap"><table className="tbl count-sheet">
          <thead><tr><th>Product ID</th><th>Product</th><th>Manufacturer</th><th className="num">System qty</th><th style={{ background: "#fff7e6", width: "9rem" }}>Counted qty</th></tr></thead>
          <tbody>{d?.rows.map((r) => <tr key={r.product_id}><td className="mono">{r.product_id}</td>
            <td><b style={{ color: "var(--ink)" }}>{r.product_name}</b>{r.product_type && <div style={{ fontSize: ".72rem", color: "var(--muted)" }}>{r.product_type}</div>}</td>
            <td>{r.manufacturer || "–"}</td><td className="num mono">{n0(r.quantity)}{r.unit_of_measurement ? ` ${r.unit_of_measurement}` : ""}</td><td style={{ borderLeft: "1px solid var(--line)" }} /></tr>)}</tbody>
        </table>{d && d.rows.length === 0 && <div className="empty"><i className="fas fa-inbox" />No products found.</div>}</div>
      </section>
    </main>
  );
}
